import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[sideBarToggler]'
})

export class SideBarDirective {
    @HostListener('click', ['$event'])
    toggleBar($event) {
        $event.preventDefault();
        document.querySelector('body').classList.toggle('sidebar-hidden');
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/directives/side-bar/side-bar.directive.ts